<template>
  <b-modal
    id="add-pto2-modal"
    :title="$t('write_off')"
    cancel-variant="outline-secondary"
    :ok-title="$t('add')"
    :ok-variant="'success'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @hidden="resetModal"
    @ok="onSubmitCategory"
  >
    <b-form>
      <validation-observer ref="ptoValidations">
        
        <b-form-group :label="$t('where3')" :for="$t('where')">
          <validation-provider
            #default="{ errors }"
            :name="$t('where')"
            rules="required"
          >
            <b-form-input type="text" v-model="ptoData.where" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group :label="$t('for_what')" :for="$t('for_what')">
          <validation-provider
            #default="{ errors }"
            :name="$t('for_what')"
            rules="required"
          >
            <b-form-input type="text" v-model="ptoData.for_what" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
       
        <b-form-group :label="$t('amount')" for="amount">
          <validation-provider
            #default="{ errors }"
            :name="$t('amount')"
            rules="required"
          >
            <b-form-input
              v-model="ptoData.count"
              id="count"
              @keyup="getVal"
            />
              <!-- onkeypress="return /[0-9,/.]/i.test(event.key)" -->
              <!-- @input="formatPrice(ptoData.count, 'count')"  -->
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BFormSpinbutton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import { required } from "@validations";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    BFormFile,
    BFormDatepicker,
    BFormTextarea,
    BFormSpinbutton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      required,
      arr: [],
      ptoData: {
        count: null,
        for_what: null,
        where: null,
      },
    };
  },
  methods: {
    ...mapActions("instruments", [
      "CREATE_INSTRUMENTS_CATEGORY",
      "FETCH_INSTRUMENTS_CATEGORY",
      "UPDATE_INSTRUMENTS_CATEGORY",
    ]),
    ...mapActions("pto", ["CREATE_PTO_FOR_GOOD"]),
    getVal(val) {
      // this.formatPrice(this.ptoData.count, 'count')
      if (this.item.total_count < this.ptoData.count) {
        this.arr = [...this.ptoData.count.toString()];

        let index = this.arr.length - 1;

        this.arr.splice(index, 1);

        let number = parseFloat(this.arr.join(""));

        this.ptoData.count = number;
      }
    },
    resetModal() {
      this.ptoData = {
        count: null,
        for_what: null,
        where: null,
      };
    },
    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.ptoValidations.validate().then((success) => {
        if (!success) {
          return;
        }

        try {
          this.CREATE_PTO_FOR_GOOD({
            good: this.item.id,
            quantity: this.ptoData.count,
            for_what: this.ptoData.for_what,
            where: this.ptoData.where,
          }).then((res) => {
            this.$_okToast();
            this.$emit("reload");
            this.$nextTick(() => {
              this.$bvModal.hide("add-pto2-modal");
            });
          });
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============






    // // ===============  SEARCH_SECTION START ===============
    // formatPrice(value, type, index) {
    //   if (value) {
    //     let currency = value.toString().replace(/,/g, "");
    //     currency = parseFloat(currency);
    //     currency = new Intl.NumberFormat("en-US", {
    //       minimumFractionDigits: 0,
    //       maximumFractionDigits: 2,
    //     }).format(currency);
        

    //     if (type == "count") {
    //       this.write_off[index].count = currency;
    //     }
    //   }
    //   return 0;
    // },
    // // ===============  SEARCH_SECTION END ===============
  },
};
</script>

<style scoped>
</style>
